import React,{useContext, useEffect} from 'react'
import {Navigate} from 'react-router-dom'
import {UserContext} from '../context/UserContext'
import AppShell from '../shell/AppShell'

/*
 * Auth guard — unchanged semantics.
 *
 * The check, the session key and the redirect target are exactly what they were:
 * only the visual wrapper moved from <Container><DashboardNav/>…<DashboardFooter/>
 * to the shared AppShell. The props contract is unchanged too: the caller still
 * passes `Component`, and an optional `title` / `eyebrow` may override the page
 * name the shell derives from the route.
 */
export default function ProtectedRoute(params) {
    const {isAuth,setIsAuth}=useContext(UserContext)

    useEffect(()=>{
        if (isAuth || (sessionStorage.getItem("isAuth")==1)){
            setIsAuth(true)
        }
    },[])

    return (
       (isAuth || (sessionStorage.getItem("isAuth")==1))
         ? <AppShell title={params.title} eyebrow={params.eyebrow}><params.Component/></AppShell>
         : <Navigate to='/login'/>
    )
}
